import * as React from 'react'

import { apiRequest } from '../../main/services/api'
import { decodeQueryString, encodeQueryString } from '../queryString'
import { redGreenGradient } from '../shared/gradients'
import BarChart from './barChart'
import MenuNew from './components/redesign/Menu'
import { CURRENCIES_LAYOUT, CURRENCIES_LIST, getActiveCurrency } from './currencyUtils'
import Menu from './menu'
import { PageType, TimeFrames } from './types'

interface CryptoPerformanceProps {
  rows: Record<string, number>
}

function getCryptoPerformanceState(props: CryptoPerformanceProps) {
  return {
    rows: props.rows,
    activeCurrency: getActiveCurrency(decodeQueryString()),
  }
}

class CryptoPerformance extends React.Component<CryptoPerformanceProps> {
  declare refreshInterval: number

  state = getCryptoPerformanceState(this.props)

  componentDidMount() {
    this.refreshInterval = window.setInterval(async () => {
      const data = await apiRequest(`/api/crypto_perf.ashx${window.location.search}`)
      if (data) {
        this.setState((prevState) => ({ ...prevState, rows: data }))
      }
    }, 30 * 1000)
  }

  componentWillUnmount() {
    clearInterval(this.refreshInterval)
  }

  _getPerformanceRowsByActiveCurrency() {
    var activeLayoutTickers = CURRENCIES_LAYOUT[this.state.activeCurrency].flat(1)
    var strippedTickers = activeLayoutTickers.map((ticker) => ticker.replace(this.state.activeCurrency, ''))
    return Object.keys(this.state.rows)
      .filter((key) => strippedTickers.includes(key) || key === this.state.activeCurrency)
      .map((key) => ({
        label: key,
        value: this.state.rows[key],
      }))
      .sort((a, b) => b.value - a.value)
  }

  render() {
    var queryString = decodeQueryString()
    var view = queryString['v'] || '1'
    var kv = { d: 1, w: 2, m: 3, mtd: 8, q: 4, hy: 5, y: 6, ytd: 7 }
    var vk: Record<string, keyof typeof kv> = {}
    Object.keys(kv).forEach((key: any) => {
      vk[kv[key as keyof typeof kv].toString()] = key
    })

    var timeframes: TimeFrames<keyof typeof kv> = {
      link: (key) => '/crypto_performance.ashx?' + encodeQueryString({ ...queryString, v: kv[key] }),
      onClick: () => {},
      active: vk[view],
      timeframes: [
        { key: 'd', value: 'D', title: 'Day' },
        { key: 'w', value: 'W', title: 'Week' },
        { key: 'm', value: 'M', title: 'Month' },
        { key: 'mtd', value: 'MTD', title: 'Month to Date' },
        { key: 'q', value: 'Q', title: 'Quarter' },
        { key: 'hy', value: 'HY', title: 'Half Year' },
        { key: 'y', value: 'Y', title: 'Year' },
        { key: 'ytd', value: 'YTD', title: 'Year To Date' },
      ],
    }

    var currencies = {
      active: this.state.activeCurrency,
      currencies: CURRENCIES_LIST,
      link: (activeCurrency: string) => {
        const queryParams = encodeQueryString({ ...queryString, c: activeCurrency })
        return `/crypto_performance.ashx${queryParams.length > 0 ? '?' : ''}${queryParams}`
      },
    }

    const isRedesignEnabled = FinvizSettings.hasRedesignEnabled
    const MenuComponent = isRedesignEnabled ? MenuNew : Menu
    return (
      <div className="futures forex flex flex-col">
        <MenuComponent activePage={PageType.Performance} timeframes={timeframes} currencies={currencies} />
        <div className="perf-chart-container">
          <div className="bar-chart-wrapper overflow-auto">
            <BarChart
              width={740}
              data={this._getPerformanceRowsByActiveCurrency()}
              onClick={() => {}}
              period={vk[view]}
              activeCurrency={this.state.activeCurrency}
              {...(isRedesignEnabled && { gradient: redGreenGradient })}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default CryptoPerformance
